import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'ipbillheaderview',
  templateUrl: './ipbillheaderview.component.html',
  styleUrls: ['./ipbillheaderview.component.scss']
})

export class  IpbillheaderviewComponent implements OnInit {
  
  @Input() hasimage: number;

  public Date: Date;

 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {
    //alert('hasimage');
    this.Date = new Date();
  }
  

 
 
 


 
}
